import { render, staticRenderFns } from "./ChildStory.vue?vue&type=template&id=2141e222&"
import script from "./ChildStory.vue?vue&type=script&lang=js&"
export * from "./ChildStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports